<template>
  <header class="header" id="header">
    <div class="container">
      <div class="row">
        <div class="col-x-lg-2 col-lg-2 col-xs-6">
          <router-link :to="'/' + $i18n.locale + '/'" class="header__logo">
            <img src="~@/assets/img/global/logo.svg" alt="" />
          </router-link>
        </div>
        <div class="col-x-lg-7 col-lg-7">
          <div class="header__nav">
            <ul>
              <li v-for="(item, key) in $t('header.nav')" :key="key">
                <router-link
                  :data-hash="item.link"
                  :to="'/' + $i18n.locale + '/' + item.link"
                  active-class="active"
                >
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-x-lg-3 col-lg-3 col-xs-6">
          <div class="header__mobile-btn">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="header__options">
            <div class="header__options-lang">
              <router-link
                tag="div"
                to="/ua/"
                class="header__options-lang-item"
                :class="{ active: $i18n.locale === 'ua' }"
              >
                ua
              </router-link>
              <router-link
                tag="div"
                to="/ru/"
                class="header__options-lang-item"
                :class="{ active: $i18n.locale === 'ru' }"
              >
                ru
              </router-link>
            </div>
            <a
              @click="headerBuy()"
              :href="$t('header.button.link')"
              target="_blank"
              class="header__options-buy"
            >
              {{ $t("header.button.title") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  methods: {
    unwrap(wrapper) {
      var docFrag = document.createDocumentFragment();
      while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
      }
      wrapper.parentNode.replaceChild(docFrag, wrapper);
    },
    responsiveHeader() {
      if (window.innerWidth <= 1199) {
        var headerNav = document.querySelector(".header__nav");
        var headerOptions = document.querySelector(".header__options");
        this.unwrap(headerNav.parentNode);
        headerNav.appendChild(headerOptions);
        this.clickOnMenuItem();
      }
    },
    toggleMenu() {
      var headerNav = document.querySelector(".header__nav");
      var menuBtn = document.querySelector(".header__mobile-btn");
      menuBtn.addEventListener("click", () => {
        menuBtn.classList.toggle("active");
        headerNav.classList.toggle("active");
      });
    },
    closeMenu() {
      var headerNav = document.querySelector(".header__nav");
      var menuBtn = document.querySelector(".header__mobile-btn");
      menuBtn.classList.remove("active");
      headerNav.classList.remove("active");
    },
    clickOnMenuItem() {
      var menuItems = document.querySelectorAll(".header__nav li a");
      var headerNav = document.querySelector(".header__nav");
      var menuBtn = document.querySelector(".header__mobile-btn");
      menuItems.forEach((item) => {
        item.addEventListener("click", () => {
          menuBtn.classList.toggle("active");
          headerNav.classList.toggle("active");
        });
      });
    },
    scrollToSection() {
      var headerHeight = document.querySelector(".header").offsetHeight;
      var headerLogo = document.querySelector(".header__logo");
      var menuItems = document.querySelectorAll(".header__nav li a");
      headerLogo.addEventListener("click", () => {
        window.scrollTo({
          top: document.getElementById("slider").offsetTop - headerHeight + 1,
          left: 0,
          behavior: "auto",
        });
      });
      menuItems.forEach((item) => {
        item.addEventListener("click", () => {
          let hash = item.getAttribute("data-hash");
          window.scrollTo({
            top: document.getElementById(hash).offsetTop - headerHeight + 1,
            left: 0,
            behavior: "auto",
          });
        });
      });
    },
    headerBuy() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "header_buy" });
    },
  },
  mounted() {
    this.scrollToSection();
    this.toggleMenu();

    var langs = document.querySelectorAll(".header__options-lang-item");
    langs.forEach((lang) => {
      lang.addEventListener("click", () => {
        var headerNav = document.querySelector(".header__nav");
        var menuBtn = document.querySelector(".header__mobile-btn");
        menuBtn.classList.remove("active");
        headerNav.classList.remove("active");
      });
    });

    this.$nextTick(() => {
      this.responsiveHeader();
    });
  },
};
</script>

<style lang="scss">
.header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px 0 19px;
  background: #f8f8f8;
  z-index: 999999;
  .container {
    @media screen and (min-width: 1440px) {
      width: 1280px;
    }
  }
  &__logo {
    display: block;
    max-width: 170px;
  }
  &__nav {
    padding-top: 20px;
    ul {
      display: flex;
      justify-content: flex-end;
      padding: 0;
      margin: 0 -15px;
      list-style: none;
      li {
        margin-left: 23px;
        &:first-child {
          margin-left: 0;
        }
        a {
          font-size: 16px;
          line-height: 19px;
          text-decoration: none;
          color: #202020;
          &.active {
            font-weight: 700;
          }
        }
      }
    }
  }
  &__mobile-btn {
    display: none;
    float: right;
    width: 32px;
    height: 21px;
    &.active {
      div {
        &:nth-child(1) {
          transform: translate(0px, 11px) rotate(45deg);
        }
        &:nth-child(2) {
          display: none;
        }
        &:nth-child(3) {
          transform: translate(0px, 2px) rotate(-45deg);
        }
      }
    }
    div {
      height: 2px;
      margin-bottom: 7px;
      background: #27cbc4;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &__options {
    display: flex;
    justify-content: flex-end;
    &-lang {
      display: flex;
      padding-top: 20px;
      &-item {
        position: relative;
        margin-left: 16px;
        text-transform: uppercase;
        color: #a9a9a9;
        cursor: pointer;
        &.active {
          font-weight: bold;
        }
        &:first-child {
          margin-left: 0;
          &:after {
            content: "|";
            position: absolute;
            top: 1px;
            right: -10px;
            font-weight: 300;
            font-size: 15px;
            line-height: 18px;
            color: #a9a9a9;
          }
        }
      }
    }
    &-buy {
      width: 151px;
      height: 48px;
      margin-top: 5px;
      margin-left: 44px;
      background: #27cbc4;
      border: 1px solid #27cbc4;
      border-radius: 5px;
      font-weight: bold;
      font-size: 20px;
      line-height: 42px;
      text-align: center;
      text-decoration: none;
      color: #ffffff;
      cursor: pointer;
      transition: background-color 0.5s;
      &:hover {
        background-color: #fff;
        color: #27cbc4;
      }
    }
  }
}
@media only screen and (max-width: 1439px) {
  .header {
    &__nav {
      ul {
        li {
          margin-left: 10px;
        }
      }
    }
  }
}
@media only screen and (max-width: 1199px) {
  .header {
    .row {
      align-items: center;
    }
    &__mobile-btn {
      display: block;
    }
    &__logo {
      max-width: 100px;
    }
    &__nav {
      position: absolute;
      top: 69px;
      left: 0;
      width: 100%;
      background: #fff;
      height: 100vh;
      overflow: auto;
      visibility: hidden;
      opacity: 0;
      z-index: 10;
      &.active {
        visibility: visible;
        opacity: 1;
      }
      ul {
        display: block;
        text-align: center;
        li {
          display: block;
          margin-left: 0;
          &:last-of-type {
            a {
              border-bottom: none;
            }
          }
          a {
            display: block;
            padding: 10px 0;
            border-bottom: 1px solid #f0f0f0;
          }
        }
      }
    }
    &__options {
      flex-direction: column;
      align-items: center;
      &-buy {
        margin-top: 15px;
        margin-left: 0;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .header {
    padding: 8px 0 9px;
    &__nav {
      top: 51px;
    }
  }
}
</style>
